import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import Whitelistips from "../../Sections/WhiteListIps";

const WhitelistComponent = () => {
    return (
        <Dashboard sectionName={<Whitelistips />}/>
    );
};

export default WhitelistComponent;
